import React from 'react';
import classNames from 'classnames';
import styles from './PopupGoogleAdsense.module.scss';
import Popup, { Props as PopupProps } from '../Popup';
import Button from '../../Button/Button';
import {
  ButtonAppearance,
  ButtonSize,
  IconPosition,
} from '../../ButtonBase/types';
import { IconGlyph } from '../../Icon';
import { Phrases } from '../../../utilities/constants/phrases';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import Title from '../../TitleWithGradient/TitleWithGradient';
import CircularTimer from '../../CircularTimer/CircularTimer';
import AdsBanner from '../../AdsBanner/AdsBanner';
import { AdsBannerSlots } from '../../../utilities/constants/common';
import { EditorPopupId } from '../../../utilities/constants/popup-type';
import { useOpenSubscriptionPopup } from '../../../hooks/popup/useOpenSubscriptionPopup';

const POPUP_ID = EditorPopupId.GOOGLE_ADSENSE;
const ADS_DURATION = 30000;
const BENEFITS = [
  Phrases.REMOVE_ADS_BENEFIT_1,
  Phrases.REMOVE_ADS_BENEFIT_2,
  Phrases.REMOVE_ADS_BENEFIT_3,
];

interface Props extends Pick<PopupProps, 'isOpen' | 'onClose'> {}

const PopupGoogleAdsense: React.FC<Props> = ({ isOpen, onClose }) => {
  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();

  return (
    <Popup
      isOpen={isOpen}
      id={POPUP_ID}
      size='lg'
      role='alertdialog'
      dialogClassName={styles.popupGoogleAdsense}>
      <div className='d-flex flex-jc-sb flex-ai-c gap-sm mb-xxxs'>
        <CircularTimer
          duration={ADS_DURATION}
          onSuccess={onClose}
        />
        <Button
          onClick={handleOpenSubscriptionPopup}
          size={ButtonSize.SMALL}
          appearance={ButtonAppearance.TEXT}
          icon={{
            glyph: IconGlyph.BROOM,
            position: IconPosition.LEFT,
          }}
          className={styles.button}>
          {Phrases.REMOVE_ADS_BUTTON_LABEL_2}
        </Button>
      </div>

      <div className={classNames(styles.adsContainer, 'd-flex gap-xs')}>
        <AdsBanner {...AdsBannerSlots.SLOT_5} />
        <AdsBanner {...AdsBannerSlots.SLOT_6} />
      </div>

      <div
        className={classNames(
          styles.removeAdsContainer,
          'd-flex flex-col flex-ai-c gap-sm'
        )}>
        <Title
          title={renderTextWithIndexedTags(Phrases.REMOVE_ADS_TITLE, [
            <span key='span-0' />,
          ])}
          className='text-xl fw-bold ta-center'
        />
        <Button onClick={handleOpenSubscriptionPopup}>
          {Phrases.REMOVE_ADS_BUTTON_LABEL}
        </Button>
        <div className='d-flex flex-ai-c gap-sm'>
          {BENEFITS.map((benefit) => (
            <div
              key={benefit}
              className={classNames(styles.benefitsItem, 'text-sm fw-medium')}>
              {benefit}
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};

export default PopupGoogleAdsense;
